























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import moment from 'moment';

@Component<MonthSelectInput>({})
export default class MonthSelectInput extends Vue {
  @Prop({ type: String, required: true })
  value: string;

  get monthParts(): [number, number] {
    const [month, year] = this.value.split('/').map(Number);
    return [year, month];
  }

  get month() {
    return this.monthParts[1];
  }
  set month(val) {
    this.$emit('input', `${val}/${this.year}`);
  }

  get year() {
    return this.monthParts[0];
  }
  set year(val) {
    this.$emit('input', `${this.month}/${val}`);
  }

  get yearOptions() {
    const currentYear = new Date().getFullYear();
    const years = Array.from(Array(10).keys());
    return years.map((y) => currentYear - y);
  }

  get monthOptions() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const maxMonth = this.year === currentYear ? currentMonth : 12;
    const months = Array.from(Array(maxMonth).keys());
    return months.map((m) => ({
      text: moment(new Date(currentYear, maxMonth - m - 1)).format('MMMM'),
      value: maxMonth - m,
    }));
  }
}
